import TagManager from 'react-gtm-module-nonce';

const tagManagerArgs = {
  gtmId: 'GTM-5SHV44J',
};
TagManager.initialize(tagManagerArgs);
